import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {UiQuestionnaireLayout, Col, UiText, Row, UiButton} from '~/components/elements';
import {BMI_27, BMI_30, NONE_OF_THE_ABOVE_VALUE, HOT_FLASHES_TREATMENT_KEYS} from '~/constants/medical-questionnaires';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {Option} from '~/redux/questionnaires/types';
import {useInput} from '~/hooks';

const Questionnaire7Screen = () => {
  const dispatch = useDispatch();
  const {questionnaires} = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const questionnaire = questionnaires?.find(
    i => i.key === HOT_FLASHES_TREATMENT_KEYS.CURRENT_OR_HISTORY_OF_ANY_OF_FOLLOWING,
  );
  const currentAnswer = useSelector(
    (state: RootState) =>
      state.questionnaires?.collectData[HOT_FLASHES_TREATMENT_KEYS.CURRENT_OR_HISTORY_OF_ANY_OF_FOLLOWING]?.data,
  );
  let medicalOptions: Option[] = [];
  if (questionnaire?.options?.length) {
    medicalOptions = questionnaire?.options?.filter(i => i?.value !== NONE_OF_THE_ABOVE_VALUE);
  }
  const defaultOptions = medicalOptions.reduce<Record<string, boolean>>((res, cur) => {
    res[cur.value] = false;

    if (currentAnswer?.selectedOptions?.length) {
      currentAnswer?.selectedOptions.map((i: string) => {
        if (i !== NONE_OF_THE_ABOVE_VALUE) res[i] = true;
      });
    }

    return res;
  }, {});

  const resetOptions = medicalOptions.reduce<Record<string, boolean>>((res, cur) => {
    res[cur.value] = false;

    return res;
  }, {});

  const {inputs, setInputs, validation} = useInput({
    defaultOptions,
    noneOptions:
      (currentAnswer?.selectedOptions?.length && currentAnswer?.selectedOptions[0] === NONE_OF_THE_ABOVE_VALUE) ||
      false,
  });
  const dataSubmit = Object.keys(inputs.defaultOptions).filter(i => inputs.defaultOptions[i] === true);
  const onClickSubmit = () => {
    dispatch(
      setQuestionnaireAnswer({
        key: HOT_FLASHES_TREATMENT_KEYS.CURRENT_OR_HISTORY_OF_ANY_OF_FOLLOWING,
        index: questionnaire?.index || '',
        data: {selectedOptions: inputs?.noneOptions ? [NONE_OF_THE_ABOVE_VALUE] : dataSubmit},
      }),
    );
    dispatch(setNextQuestionnaire({value: HOT_FLASHES_TREATMENT_KEYS.UP_TO_DATE_PAP_SMEARS_CERVICAL_SCREENINGS}));
  };
  const onClickOption = (answer: {value: string | number; label: string}) => {
    const {value} = answer;
    setInputs({noneOptions: false, defaultOptions: {...inputs.defaultOptions, [value]: !inputs.defaultOptions[value]}});
  };

  const onClickNoneOption = () => {
    setInputs({noneOptions: !inputs.noneOptions, defaultOptions: resetOptions});
  };

  return (
    <UiQuestionnaireLayout
      backIcon
      handleOnNext={onClickSubmit}
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      disableNext={!dataSubmit.length && !inputs.noneOptions}
    >
      <Col align="center" textAlign="center">
        <UiText variant="mdqTitle" mt={10} mb={5}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiText color="liteOuter" fontSize="14px">
          {questionnaire?.questions?.sub}
        </UiText>
        <Row justify="start" flexWrap="wrap" w="100%" mt={10}>
          {medicalOptions?.map(value => (
            <UiButton
              key={`${value.label}-${value.value}`}
              title={value.label}
              variant={inputs.defaultOptions[value.value] ? 'solid' : 'outlinePrimary'}
              onClick={() => onClickOption(value)}
              mr={2}
              fontSize={{base: '12px', md: '14px'}}
              fontWeight={600}
              mb={5}
              minH="35px"
            />
          ))}
        </Row>

        <UiButton
          onClick={onClickNoneOption}
          title="None of the above"
          variant={inputs.noneOptions ? 'solid' : 'toggle'}
          fontSize={{base: '14px', md: '16px'}}
          fontWeight={600}
          minH="48px"
          px={6}
          mt={5}
        />
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire7Screen;
